import PropTypes from 'prop-types'
import scheduleStatuses from 'constants/scheduleStatuses'

export default PropTypes.oneOf([
  scheduleStatuses.AHEAD,
  scheduleStatuses.BEHIND,
  scheduleStatuses.ON_SCHEDULE,
])
